import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Property {
    shortUrl: string;
    name: string;
    location: string;
    qrCode: string;
    visitCount: number;
    createdAt: string;
    latitude: string;  // or number, depending on your use case
    longitude: string; // or number, depending on your use case
    size: string;
    description: string;
    images: string[];
  }
  

interface PropertyState {
  propertyToEdit: Property | null;
}

const initialState: PropertyState = {
  propertyToEdit: null
};

const propertySlice = createSlice({
  name: 'property',
  initialState,
  reducers: {
    setPropertyToEdit: (state, action: PayloadAction<Property>) => {
      state.propertyToEdit = action.payload;
    },
    clearPropertyToEdit: state => {
      state.propertyToEdit = null;
    }
  }
});

export const { setPropertyToEdit, clearPropertyToEdit } = propertySlice.actions;

export default propertySlice.reducer;
